// 表示用フォーマッタ。金額は内部的に整数（円）で保持し、表示時のみ整形する。

const yen = new Intl.NumberFormat("ja-JP");

/** 円表示（例: 12345 → "12,345"）。記号なし。 */
export function formatYen(amount: number): string {
  return yen.format(amount);
}

/** 円表示（¥付き）。 */
export function formatYenSign(amount: number): string {
  return `¥${yen.format(amount)}`;
}

/** 符号付き円表示（+入金 / -出金）。 */
export function formatSignedYen(amount: number): string {
  const sign = amount > 0 ? "+" : amount < 0 ? "-" : "";
  return `${sign}¥${yen.format(Math.abs(amount))}`;
}

/** YYYY/MM/DD 表示。 */
export function formatDate(d: Date | string): string {
  const date = typeof d === "string" ? new Date(d) : d;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}/${m}/${day}`;
}

/** YYYY/MM/DD HH:mm 表示。 */
export function formatDateTime(d: Date | string): string {
  const date = typeof d === "string" ? new Date(d) : d;
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  return `${formatDate(date)} ${hh}:${mm}`;
}
